import { ROUTES } from 'constants/routePaths';

/**
 * Per-route content for the auth pages' left brand panel.
 * Headline is split so the accent word can be coral.
 */
export const AUTH_BRAND = {
  [ROUTES.LOGIN]: {
    pre: 'The ',
    accent: 'OS',
    post: ' for the startup ecosystem.',
    subtitle:
      'Run startups, mentors, sessions, events, grants, and reporting from one place. Built for incubators, accelerators, and venture studios.',
  },
  [ROUTES.REGISTER]: {
    pre: 'Join the ',
    accent: 'ecosystem',
    post: '.',
    subtitle:
      'Create your account to apply to programs, book mentoring, and track your startup — all in one calm place.',
  },
  [ROUTES.FORGOT_PASSWORD]: {
    pre: 'Back to ',
    accent: 'work',
    post: ' in a minute.',
    subtitle: "Enter your email and we'll send a secure code to reset your password.",
  },
  [ROUTES.SET_PASSWORD]: {
    pre: 'A fresh ',
    accent: 'start',
    post: '.',
    subtitle: 'Choose a new password and jump right back into your workspace.',
  },
};

export const DEFAULT_AUTH_BRAND = AUTH_BRAND[ROUTES.LOGIN];

export default AUTH_BRAND;
